module.exports = __webpack_public_path__ + "assets/img/block-left-e09181de.png";